import { FCAOrganisationDetails } from '../firm/firm.types';
import { API } from '@providers/ApiInterceptorProvider/useApiInterceptor';
import { CreateNetwork, Network } from './network.types';

const trimFca = (fca: string) => fca.trim();

export const networkApi = {
  getNetworkFromFcaRegister: async (fcaNumber: string) => {
    const { data: network } = await API.get<FCAOrganisationDetails>(
      `/monolith/referrers/networks/${trimFca(fcaNumber)}/club-details`,
    );
    return network;
  },

  getNetworkByFca: async (fcaNumber: string) => {
    const { data: networks } = await API.get<Network[]>(`/monolith/referrers/networks`, {
      params: {
        fca: trimFca(fcaNumber),
      },
    });
    return networks.at(0);
  },

  createNetwork: async (clubData: CreateNetwork) => {
    const { data: network } = await API.post<Network>(`/monolith/referrers/networks`, clubData);
    return network;
  },
  linkNetworkToMortgageClub: async (networkId: string, clubId: string) => {
    await API.patch(`/monolith/referrers/networks/${networkId}`, { clubId });
  },
};
